import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LazyImage from './LazyImage';

const STORAGE_KEY = 'js_recently_viewed';
const MAX_ITEMS = 8;

export function addToRecentlyViewed(product) {
  if (!product?.id) return;
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const filtered = stored.filter(p => p.id !== product.id);
    filtered.unshift({
      id: product.id,
      name: product.name,
      image_url: product.image_url,
      base_price: product.base_price,
      gender: product.gender,
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_ITEMS)));
  } catch {}
}

export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch { return []; }
}

export default function RecentlyViewed({ excludeId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const recent = getRecentlyViewed().filter(p => p.id !== excludeId);
    setItems(recent);
  }, [excludeId]);

  if (items.length === 0) return null;

  return (
    <section className="py-10 border-t border-white/5" data-testid="recently-viewed">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5 font-sans">Recently Viewed</h3>
        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
          {items.map(item => (
            <Link
              key={item.id}
              to={`/product/${item.id}`}
              className="flex-shrink-0 w-28 group"
              data-testid={`recent-${item.id}`}
            >
              <div className="aspect-[3/4] bg-[#141414] overflow-hidden mb-2">
                <LazyImage src={item.image_url} alt={item.name} className="w-full h-full group-hover:scale-105 transition-transform duration-300" />
              </div>
              <p className="text-white/60 text-xs font-sans truncate group-hover:text-[#D4AF37] transition-colors">{item.name}</p>
              <p className="text-white/30 text-xs font-sans">₱{item.base_price?.toLocaleString()}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
